import { StyleSheet } from 'react-native'

// styles
import { colorPalette } from './global'

const boardStyles = StyleSheet.create({
  boardItem: {
    flex: 1,
    backgroundColor: colorPalette.light,
    borderRadius: 8,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    minHeight: 70,
    marginHorizontal: -8,
    marginBottom: -6
  },
  boardItemDetails: {
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 10,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  boardCategory: {
    backgroundColor: colorPalette.primary,
    alignSelf: 'center',
    alignItems: 'center',
    minWidth: 200,
    marginTop: -18,
    marginBottom: 30,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 12
  },

  boardType: {
    backgroundColor: colorPalette.primary,
    borderRadius: 8,
    minWidth: 70,
    justifyContent: 'center'
  },
  boardTypeDetails: {
    alignItems: 'center'
  }
})

export { boardStyles }
